import { useState } from "react";
import { Button, TextField } from "@mui/material";

const PopAddEditModelHotspot = ({hotspot, onCreateHotspot, onClosePop, onEditHotspot, hotspotIndex}) => {

    const [hsp, setHsp] = useState({...hotspot});

    console.log(hotspotIndex);

    const onCreate = () => {
        if(hsp.title.trim() === ""){
            alert("Title is required");
            return;
        }
        onCreateHotspot(hsp);
    }

    const onUpdate = () => {
        if(hsp.title.trim() === ""){
            alert("Title is required");
            return;
        }
        onEditHotspot(hsp);
    }


    return(
        <>
        <div className="pop-background"></div>
        <div className="pop-container">
            <div className="pop-header">
                Add Edit Hotspot
            </div>
            <div className="pop-content flex flex-col gap-4">
                <TextField
                    label="Title"
                    variant="outlined"
                    value={hsp.title}
                    onChange={(e) => setHsp({...hsp, title: e.target.value})}
                />
                <TextField
                    label="Description"
                    variant="outlined"
                    value={hsp.description}
                    multiline
                    rows={4}
                    onChange={(e) => setHsp({...hsp, description: e.target.value})}
                />

            </div>
            <div className="pop-footer flex flex-row justify-start gap-4">
                <Button variant="contained" color="error" onClick={onClosePop}>Cancel</Button>
                {hotspotIndex < 0 && <Button variant="contained" color="success" onClick={onCreate}>Create and Close</Button>}
                {hotspotIndex >= 0 && <Button variant="contained" color="success" onClick={onUpdate}>Update and Close</Button>}
            </div>
        </div>
        </>
    )

}

export default PopAddEditModelHotspot;

